// extracted by mini-css-extract-plugin
export default {"more":"more___ezVLG","moreItem":"moreItem____8cKu"};